import React from "react";

const Volume = () => {
  return (
    <div class="row align-items-center bd-approach-wrap">
      <div class="col-lg-1"></div>
      <div class="col-lg-2">
        <span className="title">NETWORK: ETH</span>
      </div>
      <div class="col-lg-2">
        <span className="title">MCAP</span>
      </div>
      <div class="col-lg-2">
        <span className="title">VOLUME</span>
      </div>
      <div class="col-lg-2">
        <span className="title">HEXIDO VOLUME</span>
      </div>
      <div class="col-lg-2">
        <span className="title">PRICE</span>
      </div>
    </div>
  );
};

export default Volume;
